import type { FeedEvent } from "@/types/feed";

/** Client-side parity with the API `search` filter (SSE live events). */
export function feedEventMatchesTextSearch(
  event: FeedEvent,
  searchText?: string,
): boolean {
  const q = searchText?.trim().toLowerCase();
  if (!q) return true;
  const fields = [
    event.title,
    event.summary,
    event.reference_id ?? undefined,
    event.correlation_id ?? undefined,
  ];
  return fields.some(
    (value) => value && value.toLowerCase().includes(q),
  );
}
